import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import NoDataMessage from "../../components/noDataMessage/NoDataMessage";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { PlusCircleFill } from "react-bootstrap-icons";
import CardComponent from "../../components/CommonCards/CardComponent";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile, validateUploadedFile } from "../../utils/helpers/validateFileUpload";
import { HiArrowSmallLeft } from "react-icons/hi2";
import PageHeader from "../../components/PageHeader/PageHeader";
// import "../../pages/myConnect/ConnectTable.css";
import "../../pages/myConnect/myConnect.css"
import { LiaFileInvoiceSolid } from "react-icons/lia";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
interface ContentData {
  id: number;
  created: string;
  modified: string;
  is_delete: number;
  myconnect_master_id: number;
  document_name: string;
  image_name: string;
  mediaType: string;
  content: string;
  count: number;
  mediafiles: any;
  myconnect_folder_id?: number; // Add this line
}

interface ConnectPayload {
  content: string;
  myconnect_master_id: number;
  myconnect_folder_id: number;
}

const Items: React.FunctionComponent = () => {
  const { id, title } = useParams<{ id: string; title: string }>();
  const location = useLocation();
  const locationState = location.state as { contentData: ContentData[] };
  const { myconnect_master_id, myconnect_folder_id } = location.state || {};
  const [contentData, setContentData] = useState<ContentData[]>(
    location.state?.contentData || []
  );
  const [editingContentId, setEditingContentId] = useState<number | null>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [content, setContent] = useState("");
  const [myconnectMasterId, setMyConnectMasterId] = useState<number>(0); // Initialize with default value
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [itemFile, setItemFile] = useState<File | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [contentError, setContentError] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [contentLength, setContentLength] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [contentIdToDelete, setContentIdToDelete] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const MAX_CONTENT_LENGTH = 1000;
  const [imageFileError, setImageFileError] = useState<string | null>(null);
  const [itemFileError, setItemFileError] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isUIMounted = useRef(false);

  const handleAddCard = () => {
    setContent("");
    setImageFile(null);
    setItemFile(null);
    setEditingContentId(null);
    setShowAddModal(true);
  };

  const handleCloseModal = () => {
    setShowAddModal(false);

    setContentError("");
    setImageFileError("");
    setItemFileError("");
  };

  const fetchContentData = async (id: string) => {
    
    const payload = {
      myconnect_folder_id: 0,
      myconnect_master_id: parseInt(id, 10),
    };

    try {
      dispatch(showLoader("Loading data..."));

      const response = await postDetails(APIList.GET_FILTER_DATA, payload);
      console.log("API response:", response);

      if (
        response &&
        response.data &&
        Array.isArray(response.data.contentData)
      ) {
        setContentData(response.data.contentData);
        setMyConnectMasterId(parseInt(id, 10));
        console.log("Content Data Set:", response.data.contentData);
      } else {
        setContentData([]);
        console.log("Empty contentData set");
      }
    } catch (error) {
      console.error("Error fetching content data:", error);
      setContentData([]);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    
    if (!location.state?.contentData && id) {
      if (isUIMounted.current) return;
      isUIMounted.current = true;
      console.log(id)
      fetchContentData(id);
    }
  

   
  }, [id, location.state]);

  const handleSaveCard = async () => {
    let isValid = true;

    // Validation logic
    if (!content) {
        setContentError("Content Field is Required");
        isValid = false;
    } else {
        setContentError("");
    }

    if (!itemFile) {
        setItemFileError("This Field is Required");
        isValid = false;
    } else {
        setItemFileError("");
    }

    // If any validation fails, show an alert and return
    if (!isValid) {
        return;
    }

    setIsSaving(true);

    const formData = new FormData();
    const masterId = myconnectMasterId || (location.state?.myconnect_master_id ? parseInt(location.state.myconnect_master_id, 10) : 0);
    const folderId = location.state?.myconnect_folder_id ? parseInt(location.state.myconnect_folder_id, 10) : 0;

    const payload: ConnectPayload = {
        content,
        myconnect_master_id: masterId,
        myconnect_folder_id: folderId,
    };

    formData.append("data", encrypt(payload));

    if (imageFile) {
        formData.append("mediafiles", imageFile);
    }

    if (itemFile) {
        formData.append("docfiles", itemFile);
    }

    try {
        const response = await postMultipartDetails(APIList.ADD_ITEM, formData);

        if (response.statusCode === 200) {
            console.log("Data added successfully.");
            fetchContentData(masterId.toString());

            // Check if folderId is not zero for navigation
            if (folderId !== 0) {
                navigate(`/my-connect/${masterId}/${content}`); // Adjust as needed for correct item data
            }
            
            else {
                // Re-fetch the updated content data
                const updatedContentResponse = await postDetails(
                    APIList.GET_FILTER_DATA,
                    {
                        myconnect_folder_id: folderId,
                        myconnect_master_id: masterId,
                    }
                );

                if (
                    updatedContentResponse &&
                    updatedContentResponse.data &&
                    Array.isArray(updatedContentResponse.data.contentData)
                ) {
                    setContentData(updatedContentResponse.data.contentData);
                    console.log("Updated Content Data Set:", updatedContentResponse.data.contentData);
                } else {
                    setContentData([]);
                    console.log("Empty contentData set after update");
                }
            }
        } else {
            console.error("Failed to add data:", response.message);
        }
    } catch (error) {
        console.error("Error adding data:", error);
    } finally {
        setIsSaving(false);
        handleCloseModal();
    }
};

  const filteredContentData = contentData.filter((content) =>
    content.content.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleSearchChange = (e:any) => {
    setSearchQuery(e.target.value); // Update search query state
  };


  const handleTitleChange = (contentId: number, newTitle: string) => {
    const updatedContentData = contentData.map((content) =>
      content.id === contentId ? { ...content, content: newTitle } : content
    );
    setContentData(updatedContentData);
  };

  const handleEditClick = (contentId: number) => {
    setEditingContentId((prev) => (prev === contentId ? null : contentId));
  };

  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    contentId: number
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      const updatedData = contentData.map((content) =>
        content.id === contentId
          ? { ...content, image_name: URL.createObjectURL(file) }
          : content
      );
      setContentData(updatedData);
    }
  };

  const MAX_FILE_SIZE_MB = 15;
  const MAX_FILE_SIZE_MBB = 25;
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        setImageFileError(
          `File size should not exceed ${MAX_FILE_SIZE_MB} MB.`
        );
        return;
      }
      const validation = validateImageFile(file);
      if (!validation.valid) {
        setImageFileError(validation.message);
        return;
      }

      setImageFile(file);
      setImageFileError("");
    }
  };
  const handleItemFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      const fileSizeMB = file.size / (1024 * 1024);

      const MAX_IMAGE_SIZE_MB = 10000000000000;
      const MAX_VIDEO_SIZE_MB = 1000000000;
      const MAX_PDF_SIZE_MB = 200000000000;

      const allowedFileTypes: any = {
        "application/pdf": MAX_PDF_SIZE_MB,
        "image/jpeg": MAX_IMAGE_SIZE_MB,
        "image/png": MAX_IMAGE_SIZE_MB,
        "image/jpg": MAX_IMAGE_SIZE_MB,
        "video/mp4": MAX_VIDEO_SIZE_MB,
        "video/x-msvideo": MAX_VIDEO_SIZE_MB,
        "video/x-matroska": MAX_VIDEO_SIZE_MB,
        "video/quicktime": MAX_VIDEO_SIZE_MB,
      };

      // Validate the real file extension + MIME type, and reject deceptive
      // double-extension names (e.g. file.php.png, file.png.svg).
      const itemValidation = validateUploadedFile(
        file,
        {
          pdf: ["application/pdf"],
          png: ["image/png"],
          jpg: ["image/jpeg", "image/jpg"],
          jpeg: ["image/jpeg", "image/jpg"],
          mp4: ["video/mp4"],
          avi: ["video/x-msvideo"],
          mkv: ["video/x-matroska"],
          mov: ["video/quicktime"],
        },
        "PDF, image and video"
      );
      if (!itemValidation.valid) {
        setItemFileError(itemValidation.message);
        return;
      }

      if (!allowedFileTypes.hasOwnProperty(file.type)) {
        setItemFileError(
          "Invalid file type. Only PDF, image, and video files are allowed."
        );
        return;
      }

      const maxFileSize = allowedFileTypes[file.type];

      let errorMessage = "";
      // if (file.type.startsWith("image/")) {
      //   errorMessage = `Image file size should not exceed 10 MB.`;
      // }
      //  else if (file.type.startsWith("video/")) {
      //   errorMessage = `Video file size should not exceed 25 MB.`;
      // }
      //  else if (file.type === "application/pdf") {
      //   errorMessage = `PDF file size should not exceed 20 MB.`;
      // }

      if (fileSizeMB > maxFileSize) {
        setItemFileError(errorMessage);
        return;
      }

      setItemFileError(null);
      setItemFile(file);
    }
  };

  const handleDelete = async (contentId: number) => {
    try {
      const payload = { id: contentId };
      const response = await postDetails(APIList.DELETE_ITEM, payload);

      if (response.statusCode === 200) {
        setContentData((prevData) =>
          prevData.filter((content) => content.id !== contentId)
        );
        console.log("Item deleted successfully.");
        // dispatch(showToast("Deleted Succesfully."));

        const folderId = location.state?.myconnect_folder_id
          ? parseInt(location.state.myconnect_folder_id, 10)
          : 0;
        const masterId =
          myconnectMasterId ||
          (location.state?.myconnect_master_id
            ? parseInt(location.state.myconnect_master_id, 10)
            : 0);
        const updatedContentResponse = await postDetails(
          APIList.GET_FILTER_DATA,
          {
            myconnect_folder_id: folderId,
            myconnect_master_id: masterId,
          }
        );

        if (
          updatedContentResponse &&
          updatedContentResponse.data &&
          Array.isArray(updatedContentResponse.data.contentData)
        ) {
          setContentData(updatedContentResponse.data.contentData);
          console.log(
            "Updated Content Data Set:",
            updatedContentResponse.data.contentData
          );
        } else {
          setContentData([]);
          console.log("Empty contentData set after update");
        }
      } else {
        console.error("Failed to delete item:", response.message);
        const updatedContentResponse = await postDetails(
          APIList.GET_FILTER_DATA,
          {
            myconnect_folder_id: 0,
            myconnect_master_id: myconnectMasterId,
          }
        );

        if (
          updatedContentResponse &&
          updatedContentResponse.data &&
          Array.isArray(updatedContentResponse.data.contentData)
        ) {
          setContentData(updatedContentResponse.data.contentData);
          console.log(
            "Updated Content Data Set:",
            updatedContentResponse.data.contentData
          );
        } else {
          setContentData([]);
          console.log("Empty contentData set after update");
        }
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const MAX_CHAR_LIMIT = 150;

  const handleContentChange = (e: any) => {
    const value = e.target.value;
    if (value.length <= MAX_CHAR_LIMIT) {
      setContent(value);
    }
  };
const handleDeleteClick = (id: number) => {
    setShowDeleteModal(true);
    setContentIdToDelete(id); 
  };
  
  const handleDownloadViewUser = async () => {
    if (!startDate || !endDate) {
      // alert("Please select both start and end dates.");
      dispatch(showToast("Please Select Valid Time Period"));
      setTimeout(() => dispatch(hideToast()), 3000);

      return;
    }

    let startOffset = new Date(
      new Date(startDate).getTime() -
        new Date(startDate).getTimezoneOffset() * 60000
    ).toISOString();
    let endOffset = new Date(
      new Date(endDate).getTime() -
        new Date(endDate).getTimezoneOffset() * 60000
    ).toISOString();

    const formattedStartDate = startOffset.split("T")[0];
    const formattedEndDate = endOffset.split("T")[0];

    const payload = {
      id: id,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    console.log(payload);
    // console.log('dates', startDate, endDate, payload, startOffset.split('T')[0], endOffset.split('T')[0]);

    try {
      const response = await postDetails(APIList.DOWNLOAD_VIEW_USER, payload);

      console.log("Full API Response:", response);

      if (response.statusCode === 200) {
        console.log("API Response Data:", response.data);

        const data = response.data.map(
          (item: {
            [x: string]: string | number | Date;
            pagename: any;
            fileName: any;
            name: any;
            empcode: any;
            contact: any;
            email: any;
            viewCount:any;
          }) => ({
            pagename: item.pagename || "N/A",
            fileName: item.fileName || "N/A",
            name: item.name || "N/A",
            empcode: item.empcode || "N/A",
            contact: item.contact || "N/A",
            email: item.email || "N/A",
            viewCount: item.viewCount || "N/A",
            "date & time": item["date&time"]
              ? new Date(item["date&time"]).toLocaleString()
              : "N/A",
          })
        );

        console.log("Mapped Data for Excel:", data);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "View User Data");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(
          blob,
          `View_User_Data_${formattedStartDate}_to_${formattedEndDate}.xlsx`
        );
      } else {
        console.error("Unexpected status code:", response.statusCode);
      }
    } catch (error) {
      console.error("Error downloading view user data:", error);
    }
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date ? date : null);
    if (endDate && date && date > endDate) {
      setErrorMessage("Start date cannot be after end date.");
      setEndDate(null);
    } else {
      setErrorMessage(null);
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    if (startDate && date && date < startDate) {
      setErrorMessage("End date cannot be before start date.");
      setEndDate(null);
    } else {
      setEndDate(date ? date : null);
      setErrorMessage(null);
    }
  };

  const buttons = [
    {
      label: "Add Item",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleAddCard,
    },

    {
      label: "Back to MyConnect",
      theme: "warning",
      icon: <HiArrowSmallLeft />,
      onClick: () => navigate("/my-connect"),
    },
  ];
  const buttonn = [
    {
      label: "Download",
      theme: "warning",
      // icon: <LiaFileInvoiceSolid />,
      onClick: handleDownloadViewUser,
    },
  ];
  return (
    <LayoutContainer title="Dashboard">
        
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-dashboard"></i>
          {title}
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      <div className="download-users">
        <CustomDatePicker
          label="Start Date:"
          name="startDate"
          required={false}
          dateFormat={"MMMM d, yyyy"}
          onChange={handleStartDateChange}
          maxDate={new Date()}
        />

        <CustomDatePicker
          label="End Date: "
          name="endDate"
          required={false}
          dateFormat={"MMMM d, yyyy"}
          onChange={handleEndDateChange}
          maxDate={new Date()}
        />
        <div className="Download-btn " >
          <PageHeader buttons={buttonn} />
        </div>
      </div>
      <div className="search-bar-container">
      <InputGroup style={{ width: "340px" }} className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange} // Search input handler
        />
      </InputGroup>
</div>


     

     

      
      {/* <div className="cards-container">
        {contentData.length === 0  ? (
          <NoDataMessage />
        ) : (
          contentData.map((content: any) => (
            <CardComponent
              key={content.id}
              id={content.id}
              FolderImage=""
              document_name={content.document_name}
              content={content.content}
              count={content.count}
              documentName={content.document_name}
              image_name={content.image_name || "default-placeholder-image-url"}
              createdDate={content.created}
              isEditing={editingContentId === content.id}
              onEditClick={() => handleEditClick(content.id)}
              onImageChange={(event) => handleImageChange(event, content.id)}
              // onUpdateClick={() => handleUpdateClick(content.id)}
              onTitleChange={(newTitle) =>
                handleTitleChange(content.id, newTitle)
              }
            //   onDeleteClick={() => handleDelete(content.id)} // Pass the delete handler
            onDeleteClick={() => handleDeleteClick(content.id)}
              // myconnectMasterId={myconnectMasterId} myconnectFolderId={myconnect_folder_id}
            />
          ))
        )}
      </div> */}
       <div className="cards-container">
        {filteredContentData.length === 0 ? (
          <NoDataMessage />
        ) : (
          filteredContentData.map((content) => (
            <CardComponent
              key={content.id}
              id={content.id}
              FolderImage=""
              document_name={content.document_name}
              content={content.content}
              count={content.count}
              documentName={content.document_name}
              image_name={content.image_name || "default-placeholder-image-url"}
              createdDate={content.created}
              isEditing={editingContentId === content.id}
              onEditClick={() => handleEditClick(content.id)}
              onImageChange={(event) => handleImageChange(event, content.id)}
              onTitleChange={(newTitle) => handleTitleChange(content.id, newTitle)}
              onDeleteClick={() => handleDeleteClick(content.id)}
            />
          ))
        )}
      </div>
    
      {/* Modal Form for Adding New Content */}
      <Modal
        className="itemComponent"
        show={showAddModal}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formContent">
              <Form.Label>
                Content Name <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Content Title"
                value={content}
                onChange={handleContentChange}
              />

              {contentError && (
                <div className="error-text">{contentError}</div>
              )}

              <div className="text-muted  ">
                {content.length}/{MAX_CHAR_LIMIT}
              </div>
            </Form.Group>
            {/* <Form.Group controlId="formImageFile">
    <Form.Label>
        Image File 
    </Form.Label>
    <Form.Control
        type="file"
        onChange={handleFileChange}
        accept=".jpg,.jpeg,.png"
    />
    <Form.Text className="text-mute">
       Uploads must be JPG/JPEG/PNG
    </Form.Text>
    
    {imageFileError && <div className="text-danger">{imageFileError}</div>}
   
</Form.Group> */}

            <Form.Group controlId="formItemFile">
              <Form.Label>
                Content File <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="file"
                onChange={handleItemFileChange}
                // accept=".pdf,.doc,.docx"
              />
              <Form.Text className="text-mute">
                Uploads must be PDF/IMAGE/VIDEO
              </Form.Text>
              {itemFileError && (
                <div className="error-text">{itemFileError}</div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="my-connect-cancel-btn" onClick={handleCloseModal}>
            Close
          </button>
          <button
            className="my-connect-add-btn"
            onClick={handleSaveCard}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-warning" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button className="btn-danger"onClick={() => {
        if (contentIdToDelete !== null) {
          handleDelete(contentIdToDelete); // Use the stored id to delete the content
        }
        setShowDeleteModal(false); // Close the modal after deletion
      }}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </LayoutContainer>
  );
};

export default Items;
